/* Event PDP wiring. Two modes, chosen by data-findurl on .clone-tm-event:
   - navigate mode (data-findurl is a real path, PAGE A / event overview): Find Tickets + Select send the visitor
     to that url (the buy PDP). No cart here.
   - cart mode (data-findurl empty/0/#, PAGE B / buy PDP): Find Tickets + Select add the tier to the Shopify cart
     and go to /checkout. Variant ids come from data-* set per stop by the template. */
(function () {
  var root = document.querySelector(".clone-tm-event");
  if (!root) return;
  var V = { full: root.getAttribute("data-vfull"), vippkg: root.getAttribute("data-vvippkg"), vip: root.getAttribute("data-vvip") };
  var findUrl = (root.getAttribute("data-findurl") || "").trim();
  var navigateMode = /^\//.test(findUrl); // real path -> this is the overview page, funnel to the buy page

  function checkout(items) {
    items = items.filter(function (i) { return i.id && i.quantity > 0; });
    if (!items.length) return;
    // land on /cart (the TM-checkout cart with the "Add to your order" upsells) rather than skipping to checkout
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = "/cart"; })
      .catch(function () { window.location.href = "/cart"; });
  }
  function go() { window.location.href = findUrl; }

  // Full Price quantity stepper (the one row with data-testid="quantityStepper")
  var stepper = root.querySelector('[data-testid="quantityStepper"]');
  var val = stepper && stepper.querySelector('[role="spinbutton"]');
  // footer basket count ("×N" + "N tickets in basket"); reflects the Full Price selection
  var countEl = root.querySelector(".sc-c1a601f8-4");
  var liveEl = root.querySelector('[aria-live="polite"]');
  var fpSelected = false; // true once "Select" reveals the stepper
  function getQty() { var n = val ? parseInt(val.getAttribute("aria-valuenow"), 10) : 1; return isNaN(n) ? 1 : n; }
  function syncCount() {
    var n = fpSelected ? getQty() : 0;
    if (countEl) countEl.innerHTML = "×<!-- -->" + n;
    if (liveEl) liveEl.textContent = n + (n === 1 ? " ticket in basket" : " tickets in basket");
    // grey the bottom "Get Tickets" until Full Price is selected (ADELA greys it at x0). Use the button's native
    // :disabled state, which the TM CSS already styles grey (rgb(235,235,235)); enabled shows the green.
    var f = root.querySelector('[data-testid="findTicketsBtn"]');
    if (f) f.disabled = !fpSelected;
  }
  function setQty(n) {
    n = Math.max(0, Math.min(6, n));
    if (val) { val.setAttribute("aria-valuenow", n); val.setAttribute("aria-valuetext", n); val.textContent = n; }
    syncCount();
  }
  if (stepper) {
    var btns = stepper.querySelectorAll("button");
    if (btns[0]) btns[0].addEventListener("click", function () { setQty(getQty() - 1); });
    if (btns[1]) btns[1].addEventListener("click", function () { setQty(getQty() + 1); });
  }

  // "Select" buttons on the VIP rows
  Array.prototype.forEach.call(root.querySelectorAll('button[aria-label^="Select "]'), function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      if (navigateMode) return go();
      var id = /VIP Package/.test(b.getAttribute("aria-label") || "") ? V.vippkg : V.vip;
      checkout([{ id: Number(id), quantity: 1 }]);
    });
  });

  // ADELA parity: the Full Price row shows a "Select" button by default (like the VIP rows); clicking it reveals
  // the quantity stepper. Our TM capture baked the stepper visible, so hide it and inject the Select button.
  // (Injected AFTER the VIP wiring above so that handler's querySelectorAll snapshot never picks this up.)
  if (stepper) {
    // hide the whole stepper CELL (.sc-d2439ae2-0), not just the stepper: the empty cell keeps its ~128px width
    // and would squeeze the ticket name to a few px on mobile (letter-by-letter wrapping).
    var fpCell = stepper.parentNode;
    setQty(1); fpCell.style.display = "none"; fpSelected = false; syncCount();
    var fpWrap = document.createElement("div");
    fpWrap.className = "sc-f29de04a-0 fLdiHl";
    var fpSel = document.createElement("button");
    fpSel.type = "button";
    fpSel.setAttribute("aria-label", "Select Full Price Ticket");
    fpSel.className = "indexstyles__StyledButton-sc-83qv1q-0 icSHZa";
    fpSel.textContent = "Select";
    fpWrap.appendChild(fpSel);
    // append to the row <li> itself (like the VIP Select wrappers) so the row's flex space-between + 16px padding
    // align it exactly with the VIP Select buttons; nesting it inside the stepper's container mis-aligned it 16px.
    var fpRow = stepper.closest("li") || fpCell;
    fpRow.appendChild(fpWrap);
    fpSel.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      fpWrap.style.display = "none";
      fpCell.style.display = "";
      fpSelected = true;
      setQty(1);
    });
  }

  // Find Tickets
  var find = root.querySelector('[data-testid="findTicketsBtn"]');
  if (find) find.addEventListener("click", function (e) {
    e.preventDefault(); e.stopPropagation();
    if (navigateMode) return go();
    if (!fpSelected) return; // nothing chosen yet (Full Price not selected) - match ADELA's inert state
    checkout([{ id: Number(V.full), quantity: Math.max(1, getQty()) }]);
  });

  // The slide-in overlays (More Info / filters) start off-screen at translateX(100%). We must NOT set overflow
  // hidden on the panel itself (that clips the Select buttons at the panel edge); instead all overlays live in a
  // dedicated clip layer: absolute inset:0, overflow hidden, pointer-events none (so it never blocks the panel;
  // each visible overlay re-enables its own pointer-events). One clip layer per panel, reused by every overlay.
  function getClip(pm) {
    var clip = pm.querySelector(":scope > [data-tm-clip]");
    if (!clip) { clip = document.createElement("div"); clip.setAttribute("data-tm-clip", ""); clip.style.cssText = "position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:20"; pm.appendChild(clip); }
    return clip;
  }

  // "i" on a ticket type opens the ADELA-style "More Info" overlay that covers the ticket panel: a head with a
  // blue back-chevron + "More Info", then a card with a 4px yellow top border, a star + the ticket name, a rule
  // and the description. Built once and placed in the panel's clip layer so it overlays exactly (inset 0).
  var DESC = {
    "Full Price Ticket": "One general admission standing ticket. Standard entry to the show.",
    "Sombaddie Soundcheck + Q&A VIP Package Ticket": "One general admission standing ticket. Early entry to the standing floor section before general ticket holders and Early Entry ticket holders. Access to the exclusive pre-show soundcheck and Q&A with SOMBR. Specially designed SOMBR VIP gift item. Exclusive VIP tour poster. Pre-show tour merchandise shopping opportunity (where available).",
    "Sombaddie Early Entry VIP Package Ticket": "One general admission standing ticket. Early entry to the standing floor section before general ticket holders. Specially designed SOMBR VIP gift item. Exclusive VIP tour poster. Pre-show tour merchandise shopping opportunity (where available)."
  };
  var infoBtns = Array.prototype.filter.call(root.querySelectorAll("button"), function (b) { return /Open detailed description for:/.test(b.textContent || ""); });
  if (infoBtns.length) {
    var panelH2 = root.querySelector('[data-testid="panelTicketTypes"]');
    var panelMain = (panelH2 && panelH2.closest("main")) || (panelH2 && panelH2.offsetParent) || root;
    var STAR = 'M 12 1 A 11 11 0 0 1 12 23 A 11 11 0 0 1 12 1 M11.63 6 9.96 9.25 6.23 9.78 6 10.47 8.7 13 8.06 16.57 8.66 17 12 15.31 15.33 17 15.94 16.57 15.3 13 18 10.47 17.77 9.78 14.04 9.25 12.37 6z';
    var CHEV = 'M3.47 8.26 4.53 7.2 12 14.67 19.47 7.2 20.53 8.26 12 16.8z';
    var ov = document.createElement("div");
    ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", "More Info");
    // always in the layout; slides in from the right (transform) like ADELA, the clip layer hides the off-screen state
    ov.style.cssText = "position:absolute;inset:0;background:#fff;display:flex;flex-direction:column;font-family:inherit;transform:translateX(100%);visibility:hidden;pointer-events:auto;transition:transform .25s ease, visibility 0s linear .25s;will-change:transform";
    ov.innerHTML =
      '<div style="position:relative;display:flex;align-items:center;justify-content:center;height:56px;border-bottom:1px solid #d9d9d9;flex:none">' +
        '<button type="button" data-mi-back style="position:absolute;left:16px;top:50%;transform:translateY(-50%);width:36px;height:36px;border:0;border-radius:50%;background:#e6ebff;color:#024ddf;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true" style="transform:rotate(90deg)"><path d="' + CHEV + '"></path></svg>' +
          '<span style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Back</span>' +
        '</button>' +
        '<h2 style="font-size:18px;font-weight:600;color:#121212;margin:0">More Info</h2>' +
      '</div>' +
      '<div style="padding:16px;overflow-y:auto;-webkit-overflow-scrolling:touch">' +
        '<div style="border-top:4px solid #ffb932;background:#fff;box-shadow:0 1px 6px rgba(0,0,0,.16);padding:16px">' +
          '<div style="display:flex;align-items:center;gap:10px">' +
            '<svg viewBox="0 0 24 24" width="24" height="24" fill="#ffb932" aria-hidden="true" style="flex:none"><path fill-rule="evenodd" d="' + STAR + '"></path></svg>' +
            '<h3 data-mi-name style="font-size:18px;font-weight:700;color:#121212;margin:0;line-height:1.3"></h3>' +
          '</div>' +
          '<div style="height:1px;background:#e6e6e6;margin:14px 0"></div>' +
          '<div data-mi-text style="font-size:16px;line-height:1.5;color:#121212"></div>' +
        '</div>' +
      '</div>';
    getClip(panelMain).appendChild(ov);
    var miName = ov.querySelector("[data-mi-name]"), miText = ov.querySelector("[data-mi-text]");
    function openMI() {
      ov.style.transition = "transform .25s ease"; // visibility immediate on open, transform slides in
      ov.style.visibility = "visible";
      ov.getBoundingClientRect(); // reflow so the transform transition runs
      ov.style.transform = "translateX(0)";
    }
    function closeMI() {
      ov.style.transition = "transform .25s ease, visibility 0s linear .25s"; // keep visible during slide-out
      ov.style.transform = "translateX(100%)";
      ov.style.visibility = "hidden";
      infoBtns.forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    }
    ov.querySelector("[data-mi-back]").addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); closeMI(); });
    infoBtns.forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var name = (b.textContent || "").replace(/^[\s\S]*Open detailed description for:\s*/, "").trim();
        miName.textContent = name;
        miText.textContent = DESC[name] || "More information about this ticket type.";
        var body = ov.querySelector("[data-mi-text]").parentNode.parentNode; if (body) body.scrollTop = 0;
        openMI();
        b.setAttribute("aria-expanded", "true");
      });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && ov.style.visibility === "visible") closeMI(); });
  }

  // "All Prices" / "All Sections" pills open ADELA-style filter overlays that slide over the panel: a checklist
  // (Select All | Clear All) + Reset / Apply Filters footer. Apply filters the ticket rows and relabels the pill.
  (function () {
    var pills = Array.prototype.filter.call(root.querySelectorAll("button"), function (b) { return /^(All Prices|All Sections)$/.test((b.textContent || "").trim()); });
    if (!pills.length) return;
    var panelH2 = root.querySelector('[data-testid="panelTicketTypes"]');
    var panelMain = (panelH2 && panelH2.closest("main")) || (panelH2 && panelH2.offsetParent) || root;
    var CHEV = "M3.47 8.26 4.53 7.2 12 14.67 19.47 7.2 20.53 8.26 12 16.8z";
    var ticketRows = [].slice.call(root.querySelectorAll("li.sc-14f3239d-0"));
    function rowText(r) { return r.textContent.replace(/\s+/g, " "); }
    function rowPrice(r) { var m = rowText(r).match(/(£[\d.]+(?:–£[\d.]+)?) each/); return m ? m[1] : ""; }
    function rowSection(r) { return /VIP/i.test(rowText(r)) ? "VIP" : "General Admission"; }
    function uniq(a) { var s = [], seen = {}; a.forEach(function (x) { if (x && !seen[x]) { seen[x] = 1; s.push(x); } }); return s; }
    var state = { price: [], section: [] };
    function recompute() {
      ticketRows.forEach(function (r) {
        var okP = !state.price.length || state.price.indexOf(rowPrice(r)) !== -1;
        var okS = !state.section.length || state.section.indexOf(rowSection(r)) !== -1;
        r.style.display = (okP && okS) ? "" : "none";
      });
    }
    var overlays = [];
    function esc(s) { return (s || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); }
    function buildFilter(pill, cfg) {
      var ov = document.createElement("div");
      ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", cfg.title);
      ov.style.cssText = "position:absolute;inset:0;background:#fff;display:flex;flex-direction:column;font-family:inherit;transform:translateX(100%);visibility:hidden;pointer-events:auto;transition:transform .25s ease, visibility 0s linear .25s;will-change:transform";
      var checks = cfg.options.map(function (o) {
        return '<li><label style="display:flex;align-items:center;gap:12px;padding:14px 0;cursor:pointer;border-bottom:1px solid #ebebeb;margin:0">' +
          '<input type="checkbox" value="' + esc(o) + '" data-opt style="position:absolute;opacity:0;pointer-events:none;width:1px;height:1px">' +
          '<span data-box style="width:22px;height:22px;flex:none;border:2px solid #b3b3b3;border-radius:4px;display:inline-flex;align-items:center;justify-content:center;background:#fff"></span>' +
          '<span style="font-size:16px;color:#121212">' + o + "</span></label></li>";
      }).join("");
      ov.innerHTML =
        '<div style="position:relative;display:flex;align-items:center;justify-content:center;height:56px;border-bottom:1px solid #d9d9d9;flex:none">' +
          '<button type="button" data-back style="position:absolute;left:16px;top:50%;transform:translateY(-50%);width:36px;height:36px;border:0;border-radius:50%;background:#e6ebff;color:#024ddf;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0"><svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true" style="transform:rotate(90deg)"><path d="' + CHEV + '"></path></svg></button>' +
          '<h2 style="font-size:18px;font-weight:600;color:#121212;margin:0">' + cfg.title + "</h2>" +
        "</div>" +
        '<div style="padding:16px;overflow-y:auto;flex:1">' +
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">' +
            '<h3 style="font-size:16px;font-weight:700;color:#121212;margin:0">' + cfg.heading + "</h3>" +
            '<div style="display:flex;align-items:center;gap:10px">' +
              '<button type="button" data-all style="border:0;background:none;color:#024ddf;cursor:pointer;padding:0;font-size:14px">Select All</button>' +
              '<span aria-hidden="true" style="color:#d9d9d9">|</span>' +
              '<button type="button" data-none disabled style="border:0;background:none;color:#94a0b8;cursor:pointer;padding:0;font-size:14px">Clear All</button>' +
            "</div>" +
          "</div>" +
          '<div style="height:1px;background:#d9d9d9;margin-bottom:4px"></div>' +
          '<ul style="list-style:none;margin:0;padding:0">' + checks + "</ul>" +
        "</div>" +
        '<div style="display:flex;gap:12px;padding:16px;border-top:1px solid #d9d9d9;flex:none">' +
          '<button type="button" data-reset disabled style="flex:1;height:44px;border:1px solid #b3b3b3;background:#fff;color:#94a0b8;border-radius:4px;font-weight:600;font-size:16px;cursor:pointer">Reset</button>' +
          '<button type="button" data-apply disabled style="flex:1;height:44px;border:0;background:#024ddf;color:#fff;border-radius:4px;font-weight:600;font-size:16px;cursor:pointer;opacity:.5">Apply Filters</button>' +
        "</div>";
      getClip(panelMain).appendChild(ov);
      overlays.push(ov);
      function open() { ov.style.transition = "transform .25s ease"; ov.style.visibility = "visible"; ov.getBoundingClientRect(); ov.style.transform = "translateX(0)"; }
      function close() { ov.style.transition = "transform .25s ease, visibility 0s linear .25s"; ov.style.transform = "translateX(100%)"; ov.style.visibility = "hidden"; pill.setAttribute("aria-expanded", "false"); }
      ov._close = close; ov._open = open;
      var inputs = [].slice.call(ov.querySelectorAll("input[data-opt]"));
      var btnAll = ov.querySelector("[data-all]"), btnNone = ov.querySelector("[data-none]"), btnReset = ov.querySelector("[data-reset]"), btnApply = ov.querySelector("[data-apply]"), back = ov.querySelector("[data-back]");
      function renderBox(inp) {
        var box = inp.parentNode.querySelector("[data-box]");
        if (inp.checked) { box.style.background = "#024ddf"; box.style.borderColor = "#024ddf"; box.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="#fff" aria-hidden="true"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"></path></svg>'; }
        else { box.style.background = "#fff"; box.style.borderColor = "#b3b3b3"; box.innerHTML = ""; }
      }
      function anyChecked() { return inputs.some(function (i) { return i.checked; }); }
      function syncTools() {
        var any = anyChecked();
        btnNone.disabled = !any; btnNone.style.color = any ? "#024ddf" : "#94a0b8";
        btnApply.disabled = !any; btnApply.style.opacity = any ? "1" : ".5";
        var canReset = any || state[cfg.key].length > 0;
        btnReset.disabled = !canReset; btnReset.style.borderColor = canReset ? "#024ddf" : "#b3b3b3"; btnReset.style.color = canReset ? "#024ddf" : "#94a0b8";
      }
      inputs.forEach(function (inp) { inp.addEventListener("change", function () { renderBox(inp); syncTools(); }); renderBox(inp); });
      btnAll.addEventListener("click", function (e) { e.preventDefault(); inputs.forEach(function (i) { i.checked = true; renderBox(i); }); syncTools(); });
      btnNone.addEventListener("click", function (e) { e.preventDefault(); inputs.forEach(function (i) { i.checked = false; renderBox(i); }); syncTools(); });
      back.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      btnReset.addEventListener("click", function (e) { e.preventDefault(); inputs.forEach(function (i) { i.checked = false; renderBox(i); }); state[cfg.key] = []; recompute(); pill.textContent = cfg.defaultLabel; syncTools(); close(); });
      btnApply.addEventListener("click", function (e) {
        e.preventDefault();
        var sel = inputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
        state[cfg.key] = sel; recompute();
        pill.textContent = sel.length === 0 ? cfg.defaultLabel : (sel.length === 1 ? sel[0] : sel.length + " " + cfg.plural);
        syncTools(); close();
      });
      pill.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); open(); pill.setAttribute("aria-expanded", "true"); });
      syncTools();
    }
    pills.forEach(function (pill) {
      var isPrice = /All Prices/.test(pill.textContent || "");
      if (isPrice) buildFilter(pill, { title: "Choose Price Range", heading: "Price", plural: "Prices", defaultLabel: "All Prices", key: "price", options: uniq(ticketRows.map(rowPrice)) });
      else buildFilter(pill, { title: "Choose Section", heading: "Section", plural: "Sections", defaultLabel: "All Sections", key: "section", options: uniq(ticketRows.map(rowSection)) });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") overlays.forEach(function (o) { if (o.style.visibility === "visible") o._close(); }); });
  })();

  // Top-bar country/region selector: opens the ADELA-style right-side country roll-out (server-rendered as
  // [data-tm-cdrawer]); rows link to each country's /pages/tour-<slug> page. Same behaviour as the list page.
  (function () {
    var drawer = document.querySelector("[data-tm-cdrawer]");
    if (!drawer) return;
    var htmlEl = document.documentElement;
    var selBtns = [].slice.call(document.querySelectorAll("button[title]")).filter(function (b) { return /selected, change (country|region)/i.test(b.textContent || ""); });
    if (!selBtns.length) return;
    function onKey(e) { if (e.key === "Escape") closeD(); }
    function openD() { drawer.hidden = false; drawer.getBoundingClientRect(); drawer.classList.add("tm-open"); htmlEl.style.overflow = "hidden"; document.addEventListener("keydown", onKey); }
    function closeD() { drawer.classList.remove("tm-open"); htmlEl.style.overflow = ""; document.removeEventListener("keydown", onKey); window.setTimeout(function () { if (!drawer.classList.contains("tm-open")) drawer.hidden = true; }, 280); }
    selBtns.forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); openD(); }); });
    [].slice.call(drawer.querySelectorAll("[data-tm-cdrawer-close]")).forEach(function (el) { el.addEventListener("click", function (e) { e.preventDefault(); closeD(); }); });
  })();
})();
